<div class="input-wrapper">
  @if (label) {
  <label class="input-label" [for]="inputId">
    {{ label }}
    @if (required) {
    <span class="required-indicator">*</span>
    }
  </label>
  }

  <div
    class="input-container"
    [class.has-error]="hasError"
    [class.has-icon]="icon"
    [class.icon-left]="icon && iconPosition === 'left'"
    [class.icon-right]="icon && iconPosition === 'right'"
  >
    @if (icon && iconPosition === 'left') {
    <span class="input-icon input-icon-left">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- Icon will be provided via SVG or can be customized -->
        <path
          d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 6V10M10 14H10.01"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    }

    <input
      #inputElement
      [id]="inputId"
      class="input-field"
      [type]="type"
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      [required]="required"
      (input)="onInput($event)"
      (blur)="onBlur()"
      [attr.aria-label]="label || placeholder"
      [attr.aria-required]="required"
      [attr.aria-invalid]="hasError"
      [attr.aria-describedby]="hint || hasError ? 'input-' + inputId : null"
      [attr.maxlength]="maxLength"
    />

    @if (icon && iconPosition === 'right') {
    <span class="input-icon input-icon-right">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 6V10M10 14H10.01"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    }
  </div>

  @if (hint && !hasError) {
  <span class="input-hint">
    {{ hint }}
  </span>
  } @if (hasError) {
  <span class="input-error" role="alert">
    {{ errorText }}
  </span>
  }
</div>
